/**
 * Confinement à l'enrôlement 2FA, vu de la console (ARTO-58).
 *
 * Un compte de console dont la grâce est écoulée n'a plus le droit qu'à
 * l'enrôlement : l'API refuse tout le reste, `403 acces.refuse`,
 * `details.raison = mfa_enrolement_requis`. Deux sources le disent à la
 * console : `/v1/auth/me` (`enrolementMfaSeulement`), lu au chargement, et
 * n'importe quelle réponse refusée pour ce motif — la grâce peut s'achever
 * entre deux lectures de `/me`.
 *
 * Ce module retient la seconde : `requete()` (`api.ts`) le signale au premier
 * refus, et la garde de routage (`RequireConsoleAuth`) s'y abonne pour ne
 * plus ouvrir que `/securite`. Le signal tombe après une confirmation réussie
 * de l'enrôlement.
 */
import { useSyncExternalStore } from 'react';

let confine = false;
const abonnes = new Set<() => void>();

function notifier(): void {
  for (const abonne of abonnes) abonne();
}

/** Une réponse a été refusée pour confinement : la console se replie sur `/securite`. */
export function signalerConfinement(): void {
  if (confine) return;
  confine = true;
  notifier();
}

/** L'enrôlement est fait : la console se rouvre. */
export function leverConfinement(): void {
  if (!confine) return;
  confine = false;
  notifier();
}

/** Vrai tant qu'une réponse refusée pour confinement n'a pas été suivie d'un enrôlement. */
export function useConfinementSignale(): boolean {
  return useSyncExternalStore(
    (abonne) => {
      abonnes.add(abonne);
      return () => abonnes.delete(abonne);
    },
    () => confine,
    () => false,
  );
}
